import axios from '../axios-auth'

export const priceModelService = {
    getPriceModelList,
    savePriceModel,
    getPriceModelDetail
}

function getPriceModelList(searchParams, page, size, sortedBy) {
    let url = '/auth/price-model/';
    let params = {};
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    if (sortedBy == 'null,asc') {
        params["page"] = page;
        params["size"] = size;
    } else {
        params["page"] = page;
        params["size"] = size;
        params["sort"] = sortedBy;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get(url, { params });
}

function savePriceModel(priceModel) {
    if (!priceModel.id) {
        // new priceModel
        return axios.post("/auth/price-model", priceModel);
    } else {
        // edit
        return axios.put("/auth/price-model", priceModel);
    }
}

function getPriceModelDetail(id) {
    return axios.get("/auth/price-model/" + id);
}